/**
 * 新建处理记录
 */
import React, { useState, useEffect, useReducer, useRef } from 'react';
import {
  Form,
  Button,
  Select,
  Row,
  Col,
  message,
  Input,
  DatePicker,
  Spin,
  ConfigProvider,
  Checkbox,
  TreeSelect,
  Upload,
} from 'antd';
import {convertListToTree, formatToTree, propsDragger} from '@/utils/common';
import zhCN from 'antd/lib/locale/zh_CN';
import { PlusOutlined } from '@ant-design/icons';
import {SFuncModal} from "shj-components";
import dayjs from "dayjs";
import {iiHOC} from "@/utils/auth.ts";
import {
  addTicketsDisposeLog,
  getTicketsDisposeLog, getTicketsDisposeTicketsClassify, getTicketsInternalConfig,
  getTicketsSolutionConfig,
  ticketsGetLoginUserAttr
} from "@/services/customerServices.ts";
import {getEnums, getWorkerOrderDetail} from "@/services/homeService.ts";
import {getFileUrlPrefix} from "@/services";

const CheckboxGroup = Checkbox.Group;
const { Option } = Select;
const { TextArea } = Input;

export const ModalDisposeLogTab = (props: any) => <AddOrdercreateDisposeLogDom {...props} />;

export function addOrdercreateDisposeLogFn(val: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `新建处理记录`,
    width: 800,
    vanish: true,
    content: (
      <>
        <ConfigProvider locale={zhCN}>
          <AddOrdercreateDisposeLogDom onClose={onClose} {...val} />
        </ConfigProvider>
      </>
    ),
  });
  return dialog;
}

const AddOrdercreateDisposeLogDom = (params: any) => {
  const { onClose, fn, id, issueId, formOnly } = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const { setFieldsValue } = form;
  const [loading, setLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [fileList, setFileList] = useState([]); // 文件存放地址
  const [orderList, setOrderList] = useState([]); // 文件存放地址
  const [classifyStatus, setClassifyStatus] = useState([]);

  // const [isCreatePerson, setIsCreatePerson] = useState<any>();
  const [isDisposePerson, setIsDisposePerson] = useState<any>();
  const [isChargePerson, setIsChargePerson] = useState<any>();
  const [isCopyPerson, setIsCopyPerson] = useState<any>();
  const [currentStatus, setCurrentStatus] = useState<any>();
  const [solutionId, setSolutionId] = useState<any>();
  const [baseUrl, setBaseUrl] = useState<any>('');
  const [state, dispatch] = useReducer(
    (state, action) => {
      return action;
    },
    {
      solutionConfig: [],
    },
  );
  useEffect(() => {
    initFn();
  }, []);

  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const initFn = async () => {
    setSpinLoading(true);
    Promise.all([
      ticketsGetLoginUserAttr(id),
      getTicketsDisposeLog({id, issueId}),
      // getOptions('get', APIS.getOptionsConfig, {}),
      getTicketsSolutionConfig({data: {status: true}}),
      getEnums('plus-crm','com.shj.saas.plus.crm.domain.tickets.enums.DisposeResultEnum'),
      getTicketsDisposeTicketsClassify({ticketsId: id, isDispose: false}),
      getFileUrlPrefix(),
    ])
      .then((resp) => {
        setBaseUrl(resp[3]);
        // setIsCreatePerson(resp[0]?.isCreatePerson);
        setIsDisposePerson(resp[0]?.isDisposePerson);
        setIsChargePerson(resp[0]?.isChargePerson);
        setIsCopyPerson(resp[0]?.isCopyPerson);
        setCurrentStatus(resp[0]?.status);
        setOrderList(resp[1]?.orderList);
        setClassifyStatus(resp[4]);

        const listObj = {};
        listObj['solutionConfig'] = convertListToTree(resp[2],{pid: 'parentId'})
        listObj['disposeEnums'] = resp[3]
        dispatch(listObj);
        setSpinLoading(false);
      })
      .catch((err) => {
        setSpinLoading(false);
      });
  };
  const onFinish = () => {
    form.validateFields().then(values => {
      if (loading) return;
      setLoading(true);

      const _parameters = {
        solutionId: values.solutionId,
        classifyIdList: values.classifyIdList,
        content: values.content,
        disposeResult: values.disposeResult,
        fileReqList: fileList || [],
        disposeDate: values.disposeDate ? dayjs(values['disposeDate']).format('YYYY-MM-DD HH:mm:ss') : '',
        overDate: values.overDate ? dayjs(values['overDate']).format('YYYY-MM-DD HH:mm:ss') : '',
        ticketsId: id,
      };
      console.log('initFn', _parameters);
      return addTicketsDisposeLog(_parameters).then((resp: any) => {
        message.success(resp.message || '操作成功');
        fn && fn();
        onClose();
      }).finally((err) => setLoading(false));
    })

  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const { solutionConfig, disposeEnums } = state;
  return iiHOC(
    <SFuncModal.Content
        onCancel={onClose}
        onOk={onFinish}
        confirmLoading={loading}
    >
      <Spin spinning={spinLoading} tip="加载中...">
        {/* 
        分公司责任是-1且责任人有值 --  处理记录可添加/不显示添加责任人按钮/分公司责任人：是；
        分公司责任是-1但责任人为空  --  处理记录不可添加/显示添加责任人按钮/分公司责任人：否；
        分公司责任是0或者1,不管责任人是否有值  --  处理记录可添加/不显示添加责任人按钮/分公司责任人：否或者是 
        */}
        {spinLoading ? null : (orderList?.isCompanyCharge == -1 ? !!orderList?.chargePerson : true) ? (
          (currentStatus == 2 || currentStatus == 6 || currentStatus == 4) &&
          (isDisposePerson || isChargePerson || isCopyPerson) ? (
            <div>
              <Form
                ref={formNode}
                form={form}
                initialValues={{
                  disposeDate: dayjs(new Date()),
                }}
                labelCol={{span: 5}}
              >
                <Row gutter={2}>
                  <Col span={24}>
                    <Form.Item
                      label="预计完结时间"
                      name="overDate"
                      required
                      rules={[{ required: true, message: '请选择' }]}
                    >
                      <DatePicker
                        disabled={btnStatus(false)}
                        style={{ width: '100%' }}
                        allowClear
                        showTime={{
                          defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="工单问题分类"
                      name="classifyIdList"
                      required
                      rules={[{ required: true, message: '请选择' }]}
                    >
                      <CheckboxGroup style={{ width: '100%' }}>
                        {classifyStatus?.map((v, i) => {
                          return (
                              <Checkbox key={i} value={v.classifyId}>
                                {v.classifyName}
                              </Checkbox>
                          );
                        })}
                      </CheckboxGroup>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="处理时间"
                      name="disposeDate"
                      required
                      rules={[{ required: true, message: '请选择' }]}
                    >
                      <DatePicker
                        disabled={btnStatus(false)}
                        style={{ width: '100%' }}
                        allowClear
                        showTime={{
                          defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      label="处理结果"
                      name="disposeResult"
                      required
                      rules={[{ required: true, message: '请选择' }]}
                    >
                      <Select disabled={btnStatus(false)} placeholder="请选择" allowClear options={disposeEnums} fieldNames={{label: 'description', value: 'key'}}/>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="解决方案分类"
                      name="solutionId"
                      required
                      rules={[{ required: true, message: '请选择' }]}
                    >
                      <TreeSelect
                        showSearch
                        value={solutionId}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder="请选择"
                        allowClear
                        treeDefaultExpandAll
                        onChange={(newValue: string) => {
                          setSolutionId(newValue);
                        }}
                        treeData={solutionConfig}
                        fieldNames={{label: 'name', value: 'id'}}
                        filterTreeNode={(inputValue: any, treeNode: any) => {
                          return treeNode.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="处理方案及进度描述" name="content">
                      <TextArea disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="上传附件"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                      name="file"
                      extra="支持扩展名：.rar .zip .doc .docx .pdf .jpg .png .gif"
                    >
                      {/* <Dragger
                        style={{ width: '100%' }}
                        {...propsDragger(fileList, (val: any) => {
                          setFileList(val);
                        })}
                        listType="picture"
                      >
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">点击或者拖拽到此区域上传</p>
                        <p className="ant-upload-hint">支持扩展名：.rar .zip .doc .docx .pdf .jpg .png .gif</p>
                      </Dragger> */}
                      <Upload
                        {...propsDragger({
                          fileList,
                          baseUrl,
                          fn: (val: any) => {
                            setFileList(val);
                          },
                        })}
                        listType="picture-card"
                      >
                        <div>
                          <PlusOutlined />
                          <div style={{ marginTop: 8 }}>选择图片</div>
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                 {/* <Col span={24} style={{ textAlign: 'right' }}>
                    {!formOnly && (
                      <Button onClick={onClose} style={{ margin: '0 8px' }} loading={loading}>
                        取消
                      </Button>
                    )}
                    <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={loading}>
                      确定
                    </Button>
                  </Col>*/}
                </Row>
              </Form>
            </div>
          ) : (
            <div>当前状态或登录人不可操作</div>
          )
        ) : (
          <div>请先在工单中填写“添加责任人</div>
        )}
      </Spin>
    </SFuncModal.Content>,
  );
};
